export function SectionEyebrow({ children }: { children: React.ReactNode }) {
  return (
    <span
      data-blend
      className="inline-flex items-center gap-2.5 self-start font-mono text-[10px] font-medium uppercase tracking-[0.22em]"
    >
      <span aria-hidden className="size-1 rounded-full bg-aurora-cyan" />
      {children}
    </span>
  );
}

export function SectionTitle({
  text,
  italicLastWords = 2,
  className = "",
}: {
  text: string;
  italicLastWords?: number;
  className?: string;
}) {
  const words = text.split(" ");
  const head = words.slice(0, words.length - italicLastWords).join(" ");
  const tail = words.slice(words.length - italicLastWords).join(" ");
  return (
    <h2
      data-blend
      className={`max-w-4xl font-headline text-[clamp(2.25rem,5.5vw,4.75rem)] font-light leading-[0.94] tracking-[-0.04em] ${className}`}
    >
      {head}
      {head ? " " : null}
      <span className="font-headline italic font-light">{tail}</span>
    </h2>
  );
}
